import { create } from 'zustand';

type State = {
  message: string;
};

type Action = {
  modify: (message: string) => void;
};

const NoticeStore = create<State & Action>((set) => ({
  message: '',
  modify: (message) => {
    set({
      message,
    });
  },
}));

export default NoticeStore;
